import {
    BackendType,
    FrontendType,
    ObjectType,
    StarjackDate,
} from '@/models/general';
import { convertDateFromDateArray } from '@/utils/time';

export type Agency<T extends ObjectType = FrontendType> = {
    createdAt: StarjackDate<T>;
    id: string;
    liftOperatorId: string;
    username: string;
};

export type AgencyWithCredentials = {
    password: string;
} & Agency;

export const createEmptyAgencyWithCredentials = (): AgencyWithCredentials => ({
    createdAt: new Date(),
    id: '',
    liftOperatorId: '',
    username: '',
    password: '',
});

export const convertAgencyFromResponse = (
    agency: Agency<BackendType>
): Agency => ({
    ...agency,
    createdAt: convertDateFromDateArray(agency.createdAt),
});
